import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cf9be530"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "centered-content flex-grow-1" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-12 lg:col-6" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "text-gray-D1 mb-2" }, "Vos tags"),
  /*#__PURE__*/_createElementVNode("span", { class: "app-label text-gray-l1 font-bold" }, " Voici la liste de vos tags. ")
], -1))
const _hoisted_3 = { class: "category-container mt-4 mb-4 flex flex-wrap" }
const _hoisted_4 = { class: "flex" }
const _hoisted_5 = { class: "search-container w-full flex pannel align-items-center" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "ci-action-search" }, null, -1))
const _hoisted_7 = { class: "flex align-items-center ml-2" }
const _hoisted_8 = ["src", "alt"]
const _hoisted_9 = { class: "app-label-small font-bold text-gray-d1" }
const _hoisted_10 = { class: "app-label-small font-bold text-gray-d1" }
const _hoisted_11 = { class: "app-label-small font-bold text-gray-l1" }
const _hoisted_12 = { class: "app-label-small font-bold text-gray-l1" }
const _hoisted_13 = {
  key: 1,
  class: "grid mt-3"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CategoryCard = _resolveComponent("CategoryCard")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_TagCard = _resolveComponent("TagCard")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_CategoryCard, {
        class: "bg-gray-l1 text-white",
        iconClass: ['ci-data-iot', 'text-white'],
        count: _ctx.tags.length,
        label: "tags au total"
      }, null, 8, ["count"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _withDirectives(_createElementVNode("input", {
          class: "flex app-label-small text-gray-l1 font-bold search w-full ml-1",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filters['global'].value) = $event)),
          placeholder: "Rechercher"
        }, null, 512), [
          [_vModelText, _ctx.filters['global'].value]
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", {
          class: "flex cursor-pointer",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.activeGrid && _ctx.activeGrid(...args)))
        }, [
          _createElementVNode("i", {
            class: _normalizeClass(["ci-icon-mosaic", { currentTab: _ctx.isGrid ? true : false }]),
            style: {"font-size":"15px"}
          }, null, 2)
        ]),
        _createElementVNode("div", {
          class: "flex ml-2 cursor-pointer",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.activeList && _ctx.activeList(...args)))
        }, [
          _createElementVNode("i", {
            class: _normalizeClass(["ci-icon-menu-burger", { currentTab: !_ctx.isGrid ? true : false }]),
            style: {"font-size":"15px"}
          }, null, 2)
        ])
      ])
    ]),
    (!_ctx.isGrid)
      ? (_openBlock(), _createBlock(_component_DataTable, {
          key: 0,
          value: _ctx.its,
          filters: _ctx.filters,
          "onUpdate:filters": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.filters) = $event)),
          responsiveLayout: "stack",
          globalFilterFields: ['name', 'brand', 'setUpDate', 'zone', 'state'],
          class: "mb-3"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Column, { filed: "imgURL" }, {
              body: _withCtx(({ data }) => [
                _createElementVNode("img", {
                  src: data.imgURL,
                  alt: data.name,
                  class: "product-image"
                }, null, 8, _hoisted_8)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, {
              field: "name",
              header: "TAG",
              filterMatchMode: "contains",
              sortable: true
            }, {
              body: _withCtx(({ data }) => [
                _createElementVNode("span", _hoisted_9, _toDisplayString(data.name), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, {
              field: "brand",
              header: "MARQUE",
              filterMatchMode: "contains",
              sortable: true
            }, {
              body: _withCtx(({ data }) => [
                _createElementVNode("span", _hoisted_10, _toDisplayString(data.brand), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, {
              field: "setUpDate",
              header: "INSTALLÉ LE",
              sortable: ""
            }, {
              body: _withCtx(({ data }) => [
                _createElementVNode("span", _hoisted_11, _toDisplayString(data.setUpDate), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, {
              field: "zone",
              header: "PIÈCES CONCERCNÉES",
              sortable: true
            }, {
              body: _withCtx(({ data }) => [
                _createElementVNode("span", _hoisted_12, _toDisplayString(data.zone), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, {
              field: "state",
              header: "STATE",
              sortable: true
            }, {
              body: _withCtx(({ data }) => [
                _createElementVNode("span", {
                  class: _normalizeClass(["state-tag app-label-micro font-bold text-white", data?.state == 'REACHABLE' ? 'bg-green' : 'bg-red'])
                }, _toDisplayString(_ctx.stateName(data?.state)), 3)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["value", "filters"]))
      : (_openBlock(), _createElementBlock("div", _hoisted_13, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tags, (tag, i) => {
            return (_openBlock(), _createElementBlock("div", {
              key: tag.id || i,
              class: _normalizeClass(['flex flex-column', 'col-12 md:col-6 lg:col-3'])
            }, [
              _createVNode(_component_TagCard, { object: tag }, null, 8, ["object"])
            ]))
          }), 128))
        ]))
  ]))
}